'use client'

import { FC } from 'react'
import { useSelector } from 'shared-redux'
import { selectedMenuCategory } from 'shared-redux/state'
import { useAppConfigContext } from '#/src/appConfig'
import { MenuStandardSlideOutCategoriesDesktop } from 'storefront-modules/layout/Menu'

export interface ISlideOutCategoriesProps {}

const SlideOutCategories: FC<ISlideOutCategoriesProps> = () => {
  const appConfig = useAppConfigContext()
  const menuCategory = useSelector(selectedMenuCategory)

  return (
    <MenuStandardSlideOutCategoriesDesktop
      currentTopCategory={menuCategory}
      paths={{
        categories: appConfig.paths.categoriesUrlPath
      }}
      menuCategoriesThumbnails={appConfig.menuCategoriesThumbnails}
      topNavSlideOutFeaturedCategories={appConfig.topNavSlideOutFeaturedCategories}
      columnWrapApproach="grid"
    />
  )
}

export default SlideOutCategories
